import {
    AbcOutlined,
    BatteryChargingFullOutlined,
    ClearOutlined,
    DirectionsCarOutlined,
    ElectricCarOutlined,
    EnergySavingsLeafOutlined,
    FullscreenOutlined,
    GpsFixedOutlined,
    GridOnOutlined,
    InfoOutlined,
    InventoryOutlined,
    KeyOutlined,
    LocalGasStationOutlined,
    LocationOnOutlined,
    Man3Outlined,
    NetworkCheckOutlined,
    NotificationsActive,
    PictureAsPdfOutlined,
    PunchClockOutlined,
    RefreshOutlined,
    SatelliteAltOutlined,
    SearchOutlined,
    SeventeenMpOutlined,
    SortOutlined,
    SpeedOutlined,
    UploadFileOutlined,
    WifiOutlined,
    FingerprintOutlined,
    BadgeOutlined,
    LocationCityOutlined,
    LocalPhoneOutlined,
    WhatsApp,
    NotificationImportantOutlined
} from "@mui/icons-material";

import {
    Box,
    Chip,
    Divider,
    Drawer,
    FormControl,
    IconButton,
    Menu,
    MenuItem,
    styled,
    Switch,
    SwitchProps,
    TextField,
    Toolbar,
    Tooltip,
    Typography,
    InputAdornment,
    Checkbox,
    CheckboxProps,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Badge,
} from "@mui/material";

import { tourAnchor } from "../../../../components/introTour/introTourSteps";
import { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState, forwardRef } from "react";
import { DataGrid, GridColDef, useGridApiRef } from "@mui/x-data-grid";
import { AlertType, PermissionsType, SelectedParametersSimpleType, SelectedParametersType, UserType, VehicleGridType } from "../../../../types/types";
import { convertMetersToKilometersOdometer, formatVoltage, getFilteredList, setToastRefToOpen, formattedSpeed, getTimezone, getVehicleIgnitionStatus } from "../../../../functions/functions";
import { GRID_DEFAULT_LOCALE_TEXT } from "../../../../resources/location/utils/location";
import { MENUS_ITENS } from "../../../../consts/consts";
import { useRecoilValue } from "recoil";
import { selectedCustomerToManagerMapAtom, userAtom } from "../../../../atoms/atoms";
import { MenuItem as MenuIt } from "primereact/menuitem";
import { useCookies } from "react-cookie";
import { Toast } from "primereact/toast";
import checklistFindAllLastExportResponse from "../../../../resources/Api/checklist/checklistFindAllLastExportResponse";
import dayjs from "dayjs";
import OfflineVehiclesDialog from "./OfflineVehiclesDialog";
import VehicleFuelingDialog from "./VehicleFuelingDialog";

const items: MenuIt[] = [
    {
        label: 'PDF',
        icon: <PictureAsPdfOutlined />,
    },
    {
        label: 'Excel',
        icon: <GridOnOutlined />
    },
    {
        label: "Excel simples",
        icon: <GridOnOutlined />,
    },
];

/**const getColorByTime = (date?: string) => {
    if (!date) return "gray";

    const hoursDiff = dayjs().diff(dayjs(date), "hour");

    if (hoursDiff <= 24) return "#00B700";      // verde
    if (hoursDiff <= 48) return "#FFA500";      // laranja
    return "#FF4545";                           // vermelho
};**/

/**const getLastPositionText = (date?: string) => {
    if (!date) return "Sem informação de posição";

    const diffHours = dayjs().diff(dayjs(date), "hour");

    if (diffHours < 1) {
        const diffMinutes = dayjs().diff(dayjs(date), "minute");
        return `Última posição há ${diffMinutes} min`;
    }

    return `Última posição há ${diffHours} h`;
};**/

const getLastPositionBadge = (date?: string) => {
    if (!date) {
        return { text: "sem dados", color: "#9e9e9e" };
    }

    const now = dayjs();
    const time = dayjs(date);

    const diffMinutes = now.diff(time, "minute");
    const diffHours = now.diff(time, "hour");
    const diffDays = now.diff(time, "day");

    if (diffHours < 1) {
        return {
            text: `há ${diffMinutes} minutos`,
            color: "#2e7d32", // verde
        };
    }

    if (diffHours < 24) {
        return {
            text: `há ${diffHours} horas`,
            color: "#2e7d32", // verde
        };
    }

    if (diffHours < 48) {
        return {
            text: `há ${diffHours} horas`,
            color: "#ed6c02", // laranja
        };
    }

    return {
        text: `há ${diffDays} dias`,
        color: "#d32f2f", // vermelho
    };
};

const getRpm = (value: unknown): number | null => {
    if (typeof value !== "number" && (typeof value !== "string" || !value.trim())) return null;
    const rpm = Number(value);
    return Number.isFinite(rpm) && rpm >= 0 ? Math.round(rpm) : null;
};

const POPUP_ABOVE_FULLSCREEN_Z_INDEX = 100001;

const columns: GridColDef[] = [
    {
        field: "Filtro",
        headerName: "Filtro",
        align: "left",
        width: 100,
        sortable: false,
        editable: false,
        hideable: false,
        disableColumnMenu: false,
        renderHeader: (item) => (
            <SortOutlined
                style={{ height: 24, width: 24, fill: "#ffff" }}
            />
        ),
    },
    {
        field: "name",
        headerName: "Nome/Etiqueta",
        align: "left",
        width: 135,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.name ?? "-"}
                icon={
                    <SeventeenMpOutlined
                        style={{ height: 30, width: 30, fill: "black" }}
                    />
                }
            />
        ),
    },
    {
        field: "fixTime",
        sortable: true,
        headerName: "Data/hora",
        headerAlign: "center",
        align: "center",
        width: 150,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const fixTime = row?.position?.zonedFixTime;
            return fixTime ? dayjs(fixTime).valueOf() : 0;
        },
        renderHeader: () => (
            <WifiOutlined style={{ height: 24, width: 24, fill: "#fff" }} />
        ),
        renderCell: (item) => {
            const fixTime = item.row?.position?.zonedFixTime;
            const { text, color } = getLastPositionBadge(fixTime);
            return (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    {/* Data / Hora */}
                    <Typography className="map-grid-position-time" variant="body2" color="text.primary" fontSize={12}>
                        {fixTime
                            ? `${dayjs(fixTime).tz(getTimezone(item.row?.utcZone ?? "")).format("DD/MM/YYYY")} ${dayjs(fixTime).tz(getTimezone(item.row?.utcZone ?? "")).format("HH:mm:ss")}`
                            : "-"}
                    </Typography>

                    {/* Tarja */}
                    <Box
                        sx={{
                            backgroundColor: color,
                            color: "#fff",
                            width: "100%",
                            px: 1,
                            py: 0.25,
                            borderRadius: 0.5,
                            fontSize: 10,
                            fontWeight: 500,
                            lineHeight: 1.2,
                        }}
                    >
                        {text}
                    </Box>
                </Box>
            );
        },
    },
    {
        field: "alerts",
        headerName: "Alertas",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const hasAlerts = row?.hasAlerts;
            return hasAlerts;
        },
        renderHeader: () => (
            <NotificationImportantOutlined style={{ height: 24, width: 24, fill: "#fff" }} />
        ),
        renderCell: (params) => {
            const hasAlerts = params.row.hasAlerts;
            const alerts = params.row.alerts || [];

            if (!hasAlerts) {
                return (
                    <Typography variant="body2" sx={{ fontFamily: "Prometo", color: "gray" }}>
                        -
                    </Typography>
                );
            }

            const alertText = alerts.map((a: AlertType) => a.description || a.name || a).join(", ");
            return (
                <Tooltip title={alertText}>
                    <IconButton size="small" sx={{ color: "#d32f2f" }}>
                        <NotificationImportantOutlined />
                    </IconButton>
                </Tooltip>
            );
        }
    },
    {
        field: "ignition",
        sortable: false,
        headerName: "Ignição e movimento",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const ignition = row?.attributes?.ignition;
            return ignition;
        },
        renderHeader: () => (
            <Tooltip title="Ignição e movimento" arrow>
                <KeyOutlined style={{ height: 24, width: 24, fill: "#ffff" }} />
            </Tooltip>
        ),
        renderCell: (item) => {
            const status = getVehicleIgnitionStatus(item.row?.attributes, item.row?.position?.protocol, item.row?.idle);
            const StatusIcon = status.status === "off" ? DirectionsCarOutlined : ElectricCarOutlined;
            return (
                <Tooltip title={status.label} arrow>
                    <Chip
                        role="img"
                        aria-label={status.label}
                        tabIndex={item.hasFocus ? 0 : -1}
                        sx={{ background: "transparent" }}
                        icon={<StatusIcon className="vehicle-ignition-icon" style={{ height: 28, width: 28, fill: status.color, color: status.color }} />}
                    />
                </Tooltip>
            );
        },
    },
    {
        field: "speed",
        sortable: false,
        headerName: "Velocidade",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const speed = row?.position?.speed;
            return formattedSpeed(speed);
        },
        renderHeader: () => (
            <SpeedOutlined style={{ height: 24, width: 24, fill: "#fff" }} />
        ),
        renderCell: (params: any) => {
            const rawSpeed = params?.row?.position?.speed;
            let label = formattedSpeed(rawSpeed);
            return (
                <Chip
                    sx={{
                        background: "transparent",
                        fontFamily: "Prometo",
                    }}
                    label={label}
                />
            );
        },
    },
    {
        field: "rpm",
        sortable: false,
        headerName: "RPM",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => getRpm(row?.attributes?.rpm),
        renderCell: (item) => {
            const rpm = getRpm(item.row?.attributes?.rpm);
            return (
                <Chip
                    sx={{ background: "transparent", fontFamily: "Prometo" }}
                    label={rpm !== null ? `${rpm.toLocaleString("pt-BR")} rpm` : "-"}
                />
            );
        },
    },
    {
        field: "vehiclePlate",
        headerName: "Placa",
        align: "left",
        width: 135,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.vehiclePlate}
                icon={
                    <SeventeenMpOutlined
                        style={{ height: 30, width: 30, fill: "black" }}
                    />
                }
            />
        ),
    },
    {
        field: "driver",
        headerName: "Motorista",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => row?.driver?.name || row?.driverUnrecorded || "-",
        renderCell: (params) => {
            const driver = params.row?.driver;
            const driverUnrecorded = params.row?.driverUnrecorded;

            if (!driver?.name && !driverUnrecorded) {
                return (
                    <Typography variant="body2" sx={{ fontFamily: "Prometo", color: "gray" }}>
                        -
                    </Typography>
                );
            }

            return (
                <Tooltip
                    title={
                        <Box sx={{ p: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                                <FingerprintOutlined fontSize="small" sx={{ mr: 1 }} />
                                <Typography variant="caption">Identificador: {driver?.driverIdentifier || driverUnrecorded || "-"}</Typography>
                            </Box>
                            {driver?.name && (
                                <>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                                        <BadgeOutlined fontSize="small" sx={{ mr: 1 }} />
                                        <Typography variant="caption">Motorista: {driver.name}</Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                                        <LocationCityOutlined fontSize="small" sx={{ mr: 1 }} />
                                        <Typography variant="caption">Departamento: {driver.driverDepartmentReducedName || "-"}</Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <LocalPhoneOutlined fontSize="small" sx={{ mr: 1 }} />
                                        <Typography variant="caption">Telefone: {driver.phone || "-"}</Typography>
                                    </Box>
                                </>
                            )}
                        </Box>
                    }
                >
                    <Chip
                        sx={{
                            background: "transparent",
                            fontFamily: "Prometo",
                            cursor: "help"
                        }}
                        label={driver?.name || driverUnrecorded || "-"}
                        icon={
                            driver?.name ? (
                                <BadgeOutlined style={{ height: 24, width: 24, fill: "black" }} />
                            ) : (
                                <FingerprintOutlined style={{ height: 24, width: 24, fill: "black" }} />
                            )
                        }
                    />
                </Tooltip>
            );
        }
    },
    {
        field: "address",
        headerName: "Endereço",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const address = row?.position?.address ?? "-";
            return address;
        },
        renderCell: (item) => (
            <Tooltip title={item.row?.position?.address ?? "-"}>
                <Chip
                    sx={{
                        background: "transparent",
                        fontFamily: "Prometo",
                    }}
                    label={item.row?.position?.address}
                    icon={
                        <LocationOnOutlined style={{ height: 30, width: 30, fill: "black" }} />
                    }
                />
            </Tooltip>
        ),
    },
    {
        field: "group",
        headerName: "Grupo",
        headerAlign: "center",
        align: "center",
        width: 200,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const group = row?.groups?.length > 0 ? row?.groups.toString().replaceAll(",", ", ") : "-"
            return group;
        },
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.groups?.length > 0 ? item.row?.groups.toString().replaceAll(",", ", ") : "-"}
            />
        ),
    },
    {
        field: "sat",
        sortable: false,
        headerName: "Sinal sat",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            return row?.attributes?.sat ?? "-";
        },
        renderHeader: (item) => (
            <SatelliteAltOutlined
                style={{ height: 24, width: 24, fill: "#ffff" }}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.attributes?.sat ?? "-"}
            />
        ),
    },
    {
        field: "battery",
        sortable: false,
        headerName: "Bateria",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const power = row?.attributes?.power;
            return formatVoltage(power, "V");
        },
        renderHeader: () => (
            <BatteryChargingFullOutlined
                style={{ height: 24, width: 24, fill: "#ffff" }}
            />
        ),
        renderCell: (item) => {
            const voltage = Number(item.row?.attributes?.power);
            const vehicleType = item.row?.vehicleTypeName?.toLowerCase();

            const heavyVehicles = ["caminhão", "ônibus", "ônibus escolar"];
            const isHeavy = heavyVehicles.includes(vehicleType);
            const limitVoltage = isHeavy ? 22 : 11;
            const isLow = voltage < limitVoltage;

            return (
                <Chip
                    sx={{
                        background: "transparent",
                        fontFamily: "Prometo",
                        color: isLow ? "#ff0000" : "#00B700",
                        fontWeight: "bold",
                    }}
                    label={formatVoltage(item.row?.attributes?.power, "V")}
                />
            );
        },
    },
    {
        field: "fuel",
        sortable: false,
        headerName: "Combustível",
        headerAlign: "center",
        align: "center",
        width: 100,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            return row?.attributes?.fuel ? `${row?.attributes?.fuel} L` : row?.attributes?.fuelLevel ? `${row?.attributes?.fuelLevel}%` : "-";
        },
        renderHeader: (item) => (
            <LocalGasStationOutlined
                style={{ height: 24, width: 24, fill: "#ffff" }}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.attributes?.fuel ? `${item.row?.attributes?.fuel} L` : item.row?.attributes?.fuelLevel ? `${item.row?.attributes?.fuelLevel}%` : "-"}
            />
        ),
    },
    {
        field: "deviceImei",
        headerName: "Dispositivo",
        align: "left",
        width: 230,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            return [row?.deviceImei, row?.satelliteImei]
                .filter(Boolean)
                .join(" / ");
        },
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={[item.row?.deviceImei, item.row?.satelliteImei]
                    .filter(Boolean)
                    .join(" / ")}
                icon={
                    <SeventeenMpOutlined
                        style={{ height: 30, width: 30, fill: "black" }}
                    />
                }
            />
        ),
    },
    {
        field: "odometer",
        headerName: "Odômetro",
        align: "center",
        width: 150,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const attrs = row?.attributes || {};
            const odometerValue = (typeof attrs.io87 === 'number' && attrs.io87 > 0)
                ? attrs.io87
                : (typeof attrs.obdOdometer === 'number' && attrs.obdOdometer > 0)
                    ? attrs.obdOdometer
                    : (typeof attrs.odometer === 'number' ? attrs.odometer : null);

            return odometerValue ? String(convertMetersToKilometersOdometer(odometerValue)) : "-";
        },
        renderCell: (item) => {
            const attrs = item.row?.attributes || {};
            const odometerValue = (typeof attrs.io87 === 'number' && attrs.io87 > 0)
                ? attrs.io87
                : (typeof attrs.obdOdometer === 'number' && attrs.obdOdometer > 0)
                    ? attrs.obdOdometer
                    : (typeof attrs.odometer === 'number' ? attrs.odometer : null);

            return odometerValue ? (
                <Chip
                    sx={{
                        background: "transparent",
                        fontFamily: "Prometo",
                    }}
                    label={String(convertMetersToKilometersOdometer(odometerValue))}
                    icon={
                        <NetworkCheckOutlined
                            style={{ height: 30, width: 30, fill: "black" }}
                        />
                    }
                />
            ) : (
                <Typography>-</Typography>
            );
        }
    },
    /*{
        field: "hours",
        headerName: "Horímetro",
        align: "center",
        width: 150,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        renderCell: (item) => {
            const hoursValue = item.row?.attributes?.hours;
            return hoursValue ? (
                <Chip
                    sx={{
                        background: "transparent",
                        fontFamily: "Prometo",
                    }}
                    label={hoursValue}
                    icon={
                        <PunchClockOutlined
                            style={{ height: 30, width: 30, fill: "black" }}
                        />
                    }
                />
            ) : (
                <Typography>-</Typography>
            );
        }
    },*/
    {
        field: "lat",
        headerName: "Latitude",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const lat = row?.position?.lat ?? "-";
            return lat;
        },
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.position?.lat}
                icon={
                    <GpsFixedOutlined style={{ height: 30, width: 30, fill: "black" }} />
                }
            />
        ),
    },
    {
        field: "lng",
        headerName: "Longitude",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        disableColumnMenu: true,
        valueGetter: (_, row) => {
            const lng = row?.position?.lng ?? "-";
            return lng;
        },
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.position?.lng}
                icon={
                    <GpsFixedOutlined style={{ height: 30, width: 30, fill: "black" }} />
                }
            />
        ),
    },
    {
        field: "accessIcon",
        sortable: false,
        headerName: "Info",
        width: 120,
        disableColumnMenu: true,
        renderCell: (item) => (
            <>
                <Tooltip title="Abrir visão da rua" arrow placement="top">
                    <IconButton
                        aria-label="Abrir visão da rua"
                        onClick={() => {
                            item.row.navigate?.(item.row?.position?.lat, item.row?.position?.lng);
                        }}
                    >
                        <Man3Outlined style={{ height: 25, width: 25, fill: "#00B700" }} />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Abrir informações do veículo" arrow placement="top">
                    <IconButton
                        aria-label="Abrir informações do veículo"
                        onClick={() => {
                            item.row?.openDetails?.(item.row)
                        }}
                    >
                        <InfoOutlined style={{ height: 25, width: 25, fill: "#00B700" }} />
                    </IconButton>
                </Tooltip>
            </>
        ),
    },
];

const rowsOptions = (
    navigate: (...args: any) => void,
    list: Array<VehicleGridType>,
    openDetails?: (...args: any) => void
): Array<VehicleGridType> => {
    const result = [...list];
    return result.map((item) => ({ ...item, navigate, openDetails }));
};

const CustomCheckbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
    return (
        <Tooltip title="Selecionar para adicionar no mapa" arrow placement="top">
            <span style={{ display: "flex" }}>
                <Checkbox ref={ref} {...props} />
            </span>
        </Tooltip>
    );
});

/**
 * DrawerBottomList - Component that renders a bottom page drawer to list vehicle informations
 * @component
 */
const DrawerBottomList = ({
    setSelectedVehicle,
    setIsOpenCarsDetails,
    children,
    isHiddenMenu,
    isFixedMenu = false,
    isMenuOverlayOpen = false,
    onRefresh,
    list,
    onSelectRow,
    onSelectionChange,
    selectedVehicles,
}: {
    setSelectedVehicle: React.Dispatch<React.SetStateAction<VehicleGridType>>
    setIsOpenCarsDetails: React.Dispatch<React.SetStateAction<boolean>>
    children: JSX.Element;
    isHiddenMenu: boolean;
    isFixedMenu?: boolean;
    isMenuOverlayOpen?: boolean;
    onRefresh: () => void;
    list: Array<VehicleGridType>;
    onSelectRow: (...args: any) => void;
    onSelectionChange?: (selectedIds: readonly any[]) => void;
    selectedVehicles?: readonly any[];
}) => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    const selectedCustomerToManagerMap = useRecoilValue<SelectedParametersSimpleType>(
        selectedCustomerToManagerMapAtom
    );

    // functionalities states
    const [hideDrawerBottom, setHideDrawerBottom] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<any>>([]);

    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [drawerHeight, setDrawerheight] = useState<string>("auto");
    const [drawerWidth, setDrawerWidth] = useState<string>("calc(100% - 280px)");
    const [activePage, setActivePage] = useState<number>(0);
    const [open, setOpen] = useState<boolean>(false);

    const [isVehicleAlertOpen, setIsVehicleAlertOpen] = useState<boolean>(false);
    const [isFuelingOpen, setIsFuelingOpen] = useState<boolean>(false);
    const offlineApiRef = useGridApiRef();

    // cookies
    const [cookies] = useCookies(["selectedParameters", "token"]);

    // refs
    const anchorRef = useRef<any>(null);
    const toastRef = useRef<Toast>(null);
    const apiRef = useGridApiRef();

    const handleNext = () => {
        setActivePage((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActivePage((prevActiveStep) => prevActiveStep - 1);
    };

    const getItemPermission = useCallback((id: number) => {
        return getCurrentUser.permissions.find((permission: PermissionsType) => {
            if (permission.optionItem.id === id) {
                const { optionItem, ...rest } = permission;
                return rest;
            };
        });
    }, [getCurrentUser.permissions]);

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const permissionToCheckList = useMemo(() => getItemPermission(Number(MENUS_ITENS.CHECK_LIST)), [getItemPermission])

    const setHwValues = () => {
        if (drawerWidth === "100%") {
            setDrawerWidth("calc(100% - 280px)");
            setHideDrawerBottom(true);
        } else {
            setDrawerWidth("100%");
        }
        if (drawerHeight === "100%") {
            setDrawerheight("auto");
        } else {
            setDrawerheight("100%");
        }
    };

    useEffect(() => {
        if (!isHiddenMenu) {
            setQuery("")
        }
    }, [isHiddenMenu]);

    useEffect(() => {
        setFilteredList(getFilteredList([
            "name",
            "vehiclePlate",
            "deviceImei",
            "satelliteImei",
            "departmentName",
            "departmentSecretaryName",
            "vehicleGroupName",
            "vehicleModelName",
            "vehicleTypeName",
        ], list, query));
    }, [list, query]);

    useEffect(() => {
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                toastRef,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
        toastRef
    ]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport =
                exportType === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const onOpenStreetViewer = useCallback(async (lat: number, lng: number) => {
        const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat}%2C${lng}&heading=${0}`;
        window.open(url, "_blank");
    }, []);

    const getAllLastCheckReport = useCallback(
        async (type: string) => {
            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            const customerId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.customerId : currentParameters?.customer.id;
            const departmentId = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap.departmentId : currentParameters?.department.id;
            const isViewingAll = getCurrentUser.configs.isManager ? selectedCustomerToManagerMap?.isViewingAll : currentParameters?.isViewingAll;

            let reportType = type;
            let isSimpleType = false;
            if (type.includes("simple")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            };

            try {
                const { data }: any =
                    await checklistFindAllLastExportResponse(cookies.token, customerId, departmentId, reportType, isViewingAll, isSimpleType);

                if ((data as ArrayBuffer).byteLength === 0) {
                    setTextValidation("Nenhum dado para mostrar no relatório.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                } else {
                    setTextValidation("Relatório gerado com sucesso.");
                    setStatusMessage("success");
                    setFieldsIsValid(false);
                    dataBuffer = data;
                }
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            }
        },
        [cookies.token, currentParameters?.customer?.id, getCurrentUser.configs.isManager, currentParameters?.department?.id, currentParameters?.isViewingAll, selectedCustomerToManagerMap?.customerId,
        selectedCustomerToManagerMap?.departmentId, selectedCustomerToManagerMap?.isViewingAll,
        ]
    );

    const memoizedRows = useMemo(() => {
        return rowsOptions(onOpenStreetViewer, filteredList, (item) => {
            setIsOpenCarsDetails(true);
            setSelectedVehicle(item);
        });
    }, [filteredList, onOpenStreetViewer, setIsOpenCarsDetails, setSelectedVehicle]);

    const getHoursDiff = (date?: string) => {
        if (!date) return Infinity;
        return dayjs().diff(dayjs(date), "hour");
    };

    const offlineVehicles = useMemo(() => {
        return list.filter((item: any) => {
            const fixTime = item?.position?.zonedFixTime;
            return getHoursDiff(fixTime) >= 24;
        });
    }, [list]);

    const hasAlerts = offlineVehicles.length > 0;

    return (
        <Box className="bottom-drawer-container">
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <Box
                className="tw-shadow-xl tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                sx={{
                    position: "absolute",
                    color: "#ffff",
                    zIndex: 99999,
                    display:
                        isFuelingOpen || isMenuOverlayOpen || (!hideDrawerBottom && !isHiddenMenu) || drawerWidth === "100%"
                            ? "none"
                            : "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                    // Menu fixo ocupa os 280px da esquerda: o botão fica acima do canto da grade, não sobre o menu.
                    right: !hideDrawerBottom && isHiddenMenu ? (isFixedMenu ? "calc(100% - 328px)" : "calc(100% - 280px)") : 10,
                    width: 48,
                    height: 48,
                    border: "1px solid rgba(255, 255, 255, 0.16)",
                    borderRadius: hideDrawerBottom ? 3 : isFixedMenu ? "12px 12px 0 0" : "12px 0 0 12px",
                    bottom: 325,
                    boxShadow: "0 12px 32px rgba(9, 65, 74, 0.24)",
                }}
            >
                <Tooltip title={hideDrawerBottom ? "Abrir grade de veículos" : "Fechar grade de veículos"} arrow placement="left">
                    <IconButton
                        {...tourAnchor("map-grid")}
                        aria-label={hideDrawerBottom ? "Abrir grade de veículos" : "Fechar grade de veículos"}
                        aria-expanded={!hideDrawerBottom}
                        className="!tw-h-11 !tw-w-11 !tw-rounded-[10px] !tw-text-white tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                        onClick={() => {
                            setHideDrawerBottom(!hideDrawerBottom);
                            setQuery("");
                        }}
                    >
                        {hideDrawerBottom ? (
                            <GridOnOutlined />
                        ) : (
                            <ClearOutlined />
                        )}
                    </IconButton>
                </Tooltip>
            </Box>

            <Drawer
                className="bottom-drawer"
                anchor={"right"}
                onClose={() => { setHideDrawerBottom(!hideDrawerBottom) }}
                variant={"temporary"}
                hideBackdrop={false}
                open={!hideDrawerBottom}
                PaperProps={{
                    className:
                        "!tw-overflow-hidden !tw-rounded-tl-2xl !tw-border-0 tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth",
                }}
                sx={{
                    width: drawerWidth === "100%"
                        ? "100%"
                        : { xs: "100%", md: "calc(100% - 280px)" },
                    zIndex: drawerWidth === "100%" ? 100000 : 1200,
                    position: drawerHeight === "100%" ? "absolute" : "relative",
                    height: drawerHeight === "100%" ? "100dvh" : "auto",
                    top: "unset",
                    color: "#ffff",
                    bottom: 0,
                    margin: 0,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth === "100%"
                            ? "100%"
                            : { xs: "100%", md: "calc(100% - 280px)" },
                        top: "unset",
                        height: drawerHeight === "100%" ? "100dvh" : "auto",
                        maxHeight: "100dvh",
                        color: "#ffff",
                        backgroundColor: "#f3f4f6",
                        bottom: 0,
                        margin: 0,
                        overflow: "hidden",
                        borderTopLeftRadius: { xs: 0, md: 16 },
                        boxShadow: "0 -12px 40px rgba(0, 0, 0, 0.22)",
                    },
                }}
            >
                <Box
                    className="tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        minHeight: 0,
                        overflow: "hidden",
                        backgroundColor: "#f3f4f6",
                        alignSelf: "center",
                    }}
                >
                    <Toolbar
                        className="!tw-flex !tw-min-h-0 !tw-flex-none !tw-p-0"
                        sx={{
                            display: "flex",
                            width: "100%",
                            minHeight: 0,
                            padding: 0,
                            backgroundImage: "linear-gradient(to right, #006C77 , #09414A)",
                        }}
                    >
                        <Box
                            className="header-actions tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-2 tw-px-3 tw-py-2 sm:tw-flex-nowrap"
                            sx={{
                                display: "flex",
                                flexWrap: { xs: "wrap", sm: "nowrap" },
                                width: "100%",
                                gap: 1,
                                paddingX: { xs: 1.5, sm: 2 },
                                paddingY: 1.25,
                                alignItems: "center",
                                fontFamily: "Prometo",
                            }}
                        >
                            <Box
                                className="list-options tw-min-w-0 tw-flex-1 tw-truncate tw-text-sm tw-font-bold tw-text-white"
                                sx={{
                                    minWidth: { xs: "100%", sm: 120 },
                                    flex: 1,
                                    overflow: "hidden",
                                    color: "#ffff",
                                    fontWeight: 700,
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {selectedCustomerToManagerMap.reducedName}
                            </Box>

                            <Box
                                className="list-options tw-min-w-0 tw-flex-[2]"
                                sx={{
                                    minWidth: { xs: "calc(100% - 8px)", sm: 260 },
                                    flex: 2,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Nome, placa, grupo, tipo, dispositivo ou modelo."
                                    value={query}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setQuery(e.target.value);
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchOutlined style={{ color: "rgba(255, 255, 255, 0.7)" }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: query ? (
                                            <InputAdornment position="end">
                                                <Tooltip title="Limpar pesquisa" arrow placement="top">
                                                    <IconButton
                                                        size="small"
                                                        aria-label="Limpar pesquisa"
                                                        onClick={() => setQuery("")}
                                                        style={{ color: "rgba(255, 255, 255, 0.7)" }}
                                                    >
                                                        <ClearOutlined fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ) : null,
                                        style: {
                                            fontFamily: "Prometo",
                                            color: "#fff",
                                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                                            borderRadius: "8px",
                                            paddingRight: 8,
                                        }
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            minHeight: 44,
                                            transition: "background-color 200ms ease, box-shadow 200ms ease",
                                            "& fieldset": { border: "none" },
                                            "&:hover fieldset": { border: "none" },
                                            "&.Mui-focused fieldset": { border: "1px solid rgba(255, 255, 255, 0.5)" },
                                            "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.10)" },
                                        },
                                        "& input::placeholder": {
                                            color: "rgba(255, 255, 255, 0.72)",
                                            opacity: 1,
                                        },
                                    }}
                                />
                            </Box>

                            <Box
                                className="list-options tw-flex tw-flex-none tw-items-center tw-justify-end tw-gap-0.5"
                                sx={{
                                    display: "flex",
                                    position: "relative",
                                    zIndex: 2,
                                    flexShrink: 0,
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    gap: 0.25,
                                    "& .MuiIconButton-root": {
                                        transition: "background-color 200ms ease, transform 200ms ease",
                                    },
                                    "& .MuiIconButton-root:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.12)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                <>
                                    {hasAlerts && (
                                        <Tooltip title={`${offlineVehicles.length} veículo(s) sem comunicação há mais de 24h`} arrow placement="top">
                                            <IconButton
                                                aria-label="Visualizar veículos sem comunicação"
                                                onClick={() => setIsVehicleAlertOpen(true)}
                                                style={{ transition: "all 0.2s ease-out allow-discrete" }}
                                            >
                                                <Badge badgeContent={offlineVehicles.length} color="error">
                                                    <NotificationsActive style={{ color: "#FF4545" }} />
                                                </Badge>
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                    <Tooltip title="Abastecimentos" arrow placement="top">
                                        <IconButton
                                            aria-label="Abastecimentos"
                                            onClick={() => setIsFuelingOpen(true)}
                                            style={{ transition: "all 0.2s ease-out allow-discrete" }}
                                        >
                                            <LocalGasStationOutlined style={{ color: "#ffff" }} />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Checagem dos veículos" arrow placement="top">
                                        <span>
                                            <IconButton
                                                ref={(ref) => anchorRef.current = ref}
                                                className="refresh-button-icon"
                                                aria-label="Checagem dos veículos"
                                                disabled={!permissionToCheckList?.canView}
                                                onClick={() => setOpen(true)}
                                                sx={{
                                                    marginRight: "3px",
                                                    width: "45px",
                                                    height: "45px",
                                                }}
                                            >
                                                <InventoryOutlined style={{ color: !permissionToCheckList?.canView ? "#dbdbdb48" : "#ffff" }} />
                                            </IconButton>
                                        </span>
                                    </Tooltip>

                                    <Menu
                                        open={open}
                                        anchorEl={() => anchorRef.current as HTMLElement}
                                        sx={{ zIndex: POPUP_ABOVE_FULLSCREEN_Z_INDEX }}
                                        onClose={() => { setOpen(false) }}
                                    >
                                        {items.map((option: MenuIt) => (
                                            <MenuItem key={option?.id} onClick={(e: any) => {
                                                setOpen(false);
                                                getAllLastCheckReport(option.label!!.toLocaleLowerCase())
                                            }}>
                                                {` ${option.label}`}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </>

                                <Tooltip title="Exportar grade" arrow placement="top">
                                    <IconButton
                                        aria-label="Exportar grade"
                                        onClick={() => {
                                            apiRef.current.exportDataAsCsv({
                                                fileName: "grade-veiculos-ativos",
                                                delimiter: ";",
                                                fields: [
                                                    "name",
                                                    "group",
                                                    "vehiclePlate",
                                                    "fixTime",
                                                    "ignition",
                                                    "speed",
                                                    "rpm",
                                                    "battery",
                                                    "fuel",
                                                    "deviceImei",
                                                    "odometer",
                                                    "lat",
                                                    "lng",
                                                    "address"
                                                ]
                                            })
                                        }}
                                        style={{ transition: "all 0.2s ease-out allow-discrete" }}
                                    >
                                        <UploadFileOutlined style={{ color: "#ffff" }} />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Recarregar" arrow placement="top">
                                    <IconButton
                                        aria-label="Recarregar"
                                        onClick={() => onRefresh()}
                                        style={{ transition: "all 0.2s ease-out allow-discrete" }}
                                    >
                                        <RefreshOutlined style={{ color: "#ffff" }} />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Tela cheia" arrow placement="top">
                                    <IconButton
                                        aria-label="Alternar tela cheia"
                                        onClick={() => { setHwValues() }}
                                        style={{ transition: "all 0.2s ease-out allow-discrete" }}
                                    >
                                        <FullscreenOutlined style={{ color: "#ffff" }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Toolbar>
                    <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.24)" }} />
                    <Box
                        className="tw-m-2 tw-min-h-0 tw-flex-1 tw-overflow-hidden tw-rounded-xl tw-bg-white tw-shadow-sm"
                        sx={{
                            minHeight: 0,
                            flex: 1,
                            margin: 1,
                            overflow: "hidden",
                            border: "1px solid rgba(0, 63, 74, 0.10)",
                            borderRadius: 3,
                            backgroundColor: "#ffff",
                            boxShadow: "0 4px 18px rgba(0, 0, 0, 0.06)",
                            fontFamily: "Prometo",
                        }}
                    >
                        {!loading ? (
                            <DataGrid
                                sx={{
                                    color: "#0C79AD",
                                    fontWeight: "bolder",
                                    margin: 0,
                                    fontSize: 14,
                                    fontFamily: "Prometo",
                                    height: drawerHeight === "100%" ? "100%" : "300px",
                                    minHeight: drawerHeight === "100%" ? 0 : "300px",
                                    border: "none",
                                    scrollbarColor: "#c1c1c1 transparent",
                                    "& .MuiCheckbox-root": {
                                        color: "#0C79AD",
                                        transition: "all 0.2s ease",
                                        "& svg": {
                                            fontSize: "26px",
                                            borderRadius: "6px",
                                        },
                                        "&:hover": {
                                            backgroundColor: "rgba(12, 121, 173, 0.08)",
                                            transform: "scale(1.05)",
                                        },
                                        "&.Mui-checked": {
                                            color: "#0C79AD",
                                            "& svg": {
                                                transform: "scale(1.1)",
                                                transition: "transform 0.2s ease-in-out",
                                                filter: "drop-shadow(0px 2px 4px rgba(12, 121, 173, 0.4))"
                                            }
                                        }
                                    },
                                    "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                                        color: "#0C79AD",
                                        backgroundColor: "transparent",
                                        "&.Mui-checked": {
                                            color: "#0C79AD",
                                        }
                                    }
                                }}
                                apiRef={apiRef}
                                checkboxSelection={true}
                                rowSelectionModel={selectedVehicles}
                                keepNonExistentRowsSelected
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    if (onSelectionChange) {
                                        onSelectionChange(newSelectionModel);
                                    }
                                }}
                                className="datagrid-selectable"
                                rows={memoizedRows}
                                localeText={GRID_DEFAULT_LOCALE_TEXT}
                                initialState={{
                                    columns: {
                                        orderedFields: ["Filtro", "__check__"],

                                    }
                                }}
                                onRowClick={({ row }) => {
                                    onSelectRow(row);
                                }}
                                columns={columns}
                                paginationModel={{
                                    page: activePage,
                                    pageSize: drawerHeight === "100%" ? 100 : 100,
                                }}
                                slotProps={{
                                    pagination: {
                                        count: filteredList.length,
                                        page: activePage,
                                        nextIconButtonProps: {
                                            onClick: () => handleNext(),
                                            disabled: activePage >= Math.max(0, Math.ceil(filteredList.length / (drawerHeight === "100%" ? 100 : 100)) - 1)
                                        },
                                        backIconButtonProps: {
                                            onClick: () => handleBack(),
                                            disabled: activePage === 0
                                        },
                                    },
                                    columnsManagement: {
                                        getTogglableColumns: (columns) =>
                                            columns.filter((col) => col.field !== '__check__').map((col) => col.field)
                                    },
                                    // Em tela cheia a gaveta usa zIndex 100000; menu e painéis precisam ficar acima.
                                    basePopper: {
                                        sx: { zIndex: POPUP_ABOVE_FULLSCREEN_Z_INDEX },
                                    },
                                }}
                                pageSizeOptions={[100]}
                                slots={{
                                    baseCheckbox: CustomCheckbox
                                }}
                                getRowClassName={(row) =>
                                    row.row.approved ? "disabled-row" : ""
                                }
                                disableRowSelectionOnClick
                                density="compact"
                            />
                        ) : (
                            <div
                                style={{
                                    width: "100%",
                                    padding: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                }}
                            >
                                <div className="tracker-loading">
                                    <div className="ld-tracker">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Box>
                </Box>
                <OfflineVehiclesDialog
                    open={isVehicleAlertOpen}
                    onClose={() => setIsVehicleAlertOpen(false)}
                    offlineVehicles={offlineVehicles}
                />
                <VehicleFuelingDialog
                    open={isFuelingOpen}
                    onClose={() => setIsFuelingOpen(false)}
                    token={cookies.token}
                    customerId={getCurrentUser.configs.isManager ? selectedCustomerToManagerMap?.customerId : currentParameters?.customer?.id}
                    vehicles={list}
                />
            </Drawer>
            {children}
        </Box>
    );
};

export default DrawerBottomList;
